import { stripPhone } from '../../lib/utils';

export const VIBER_URL = `viber://pa?chatURI=${config.SUPPORT_VIBER}`;
export const TELEGRAM_URL = `https://t.me/${config.SUPPORT_TELEGRAM}`;
export const PHONE_URL = `tel:${stripPhone(config.SUPPORT_PHONE)}`;
export const MAIL_URL = `mailto:${config.SUPPORT_EMAIL}`;
